import React, { useEffect } from "react"
import { Route, Routes, Outlet, useLocation } from "react-router-dom"

import { Top } from "src/pages/top"
import { Reservations } from "src/pages/consult"
import { FaqPage } from "src/pages/faq"
import { NewsPage } from "src/pages/news"
import { NewsDetailPage } from "src/pages/news/detail"
import { MyPage } from "src/pages/mypage"
import Layout from "src/components/layout"
import { UserTypeSelection } from "./pages/signup/user_type"
import { SignupUser } from "./pages/signup/user"
import { SignupAdivser } from "./pages/signup/adviser"
import { SignupCompany } from "./pages/signup/company"
import { SignupAdministrator } from "./pages/signup/administrator"
import { Signup } from "./pages/signup"
import { EmailVerification } from "./pages/signup/verify"
import { Signin } from "./pages/signin"
import { EmailConfirm } from "./pages/password_reset/EmailConfirm"
import { PasswordReset } from "./pages/password_reset"
import { EventPage } from "./pages/event"
import { SpaceMeetingPage } from "src/pages/space_meeting"
import { BookLibraryPage } from "src/pages/book_library"
import { ServiceIntroductionPage } from "src/pages/job_offer/service_introduction"
import { JobOfferPage } from "src/pages/job_offer/job_offer"
import { AdviserPage } from "./pages/adviser"
import { AdviserDetailPage } from "./pages/adviser/AdviserDetail"
import { AdviserReservationPage } from "./pages/adviser/AdviserReservation"
import { ContactUs } from "./pages/contactUs"
import { useRecoilState } from "recoil"
import { ShowHeader } from "./states/showHeader"
import { MENU_TYPE, SUB_MENU_TYPE } from "./modules/const"
import { PrivacyPolicy } from "./pages/privacy_policy"
import { TermOfUse } from "./pages/term_of_use"
import { OpenAPI } from "./openapi"
import { OpenAPI as AddressOpenAPI } from "./openapi_address"

export function Body() {
  OpenAPI.BASE = process.env.REACT_APP_API_URL
  AddressOpenAPI.BASE = process.env.REACT_APP_ADDRESS_API_URL

  const location = useLocation()

  const [, setShowHeader] = useRecoilState(ShowHeader)

  useEffect(() => {
    if (location.pathname.startsWith("/mypage")) {
      setShowHeader(false)
    } else {
      setShowHeader(true)
    }
  }, [location])

  return (
    <Routes>
      <Route
        element={
          <Layout>
            <Outlet />
          </Layout>
        }
      >
        <Route path="/" element={<Top />} />
        <Route path="/reservations" element={<Reservations />} />
        <Route path="/signup/type" element={<UserTypeSelection />} />
        <Route path="/signup/user/detail" element={<SignupUser />} />
        <Route path="/signup/adviser/detail" element={<SignupAdivser />} />
        <Route path="/signup/company/detail" element={<SignupCompany />} />
        <Route path="/signup/admin/detail" element={<SignupAdministrator />} />
        <Route path="/signup/verification" element={<EmailVerification />} />
        <Route path="/signup/:type" element={<Signup />} />
        <Route path="/signin/" element={<Signin />} />
        <Route path="/password_reset/email" element={<EmailConfirm />} />
        <Route path="/password_reset" element={<PasswordReset />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:id" element={<NewsDetailPage />} />
        <Route path="/event" element={<EventPage />} />
        <Route path="/adviser" element={<AdviserPage />} />
        <Route path="/adviser/detail" element={<AdviserDetailPage />} />
        <Route path="/adviser/reservation" element={<AdviserReservationPage />} />
        <Route
          path="/mypage"
          element={<MyPage mainIndex={MENU_TYPE.INBOX} subIndex={SUB_MENU_TYPE.INBOX_CONSULT} />}
        />
        <Route
          path="/mypage/inbox/consult"
          element={<MyPage mainIndex={MENU_TYPE.INBOX} subIndex={SUB_MENU_TYPE.INBOX_CONSULT} />}
        />
        <Route
          path="/mypage/inbox/event"
          element={<MyPage mainIndex={MENU_TYPE.INBOX} subIndex={SUB_MENU_TYPE.INBOX_EVENT} />}
        />
        <Route
          path="/mypage/inbox/contact"
          element={<MyPage mainIndex={MENU_TYPE.INBOX} subIndex={SUB_MENU_TYPE.INBOX_CONTACT} />}
        />
        <Route
          path="/mypage/favorite"
          element={<MyPage mainIndex={MENU_TYPE.FAVORITE_VIDEO} subIndex={0} />}
        />
        <Route
          path="/mypage/contact"
          element={<MyPage mainIndex={MENU_TYPE.CONTACT} subIndex={0} />}
        />
        <Route
          path="/mypage/profile/update"
          element={
            <MyPage
              mainIndex={MENU_TYPE.REGISTER_INFORMATION}
              subIndex={SUB_MENU_TYPE.REGISTER_INFO_CHANGE}
            />
          }
        />
        <Route
          path="/mypage/profile/password"
          element={
            <MyPage
              mainIndex={MENU_TYPE.REGISTER_INFORMATION}
              subIndex={SUB_MENU_TYPE.REGISTER_PASS_CHANGE}
            />
          }
        />
        <Route
          path="/mypage/event/list"
          element={
            <MyPage mainIndex={MENU_TYPE.EVENT_MANAGE} subIndex={SUB_MENU_TYPE.EVENT_LIST} />
          }
        />
        <Route
          path="/mypage/event/list/receiving"
          element={
            <MyPage
              mainIndex={MENU_TYPE.EVENT_MANAGE}
              subIndex={SUB_MENU_TYPE.EVENT_LIST_RECEIVING}
            />
          }
        />
        <Route
          path="/mypage/event/list/started"
          element={
            <MyPage
              mainIndex={MENU_TYPE.EVENT_MANAGE}
              subIndex={SUB_MENU_TYPE.EVENT_LIST_STARTED}
            />
          }
        />
        <Route
          path="/mypage/event/list/archived"
          element={
            <MyPage
              mainIndex={MENU_TYPE.EVENT_MANAGE}
              subIndex={SUB_MENU_TYPE.EVENT_LIST_ARCHIVED}
            />
          }
        />
        <Route
          path="/mypage/event/list/draft"
          element={
            <MyPage mainIndex={MENU_TYPE.EVENT_MANAGE} subIndex={SUB_MENU_TYPE.EVENT_LIST_DRAFT} />
          }
        />
        <Route
          path="/mypage/event/create"
          element={
            <MyPage mainIndex={MENU_TYPE.EVENT_MANAGE} subIndex={SUB_MENU_TYPE.EVENT_CREATE} />
          }
        />
        <Route
          path="/mypage/event/:id"
          element={
            <MyPage mainIndex={MENU_TYPE.EVENT_MANAGE} subIndex={SUB_MENU_TYPE.EVENT_EDIT} />
          }
        />
        <Route
          path="/mypage/news/create"
          element={
            <MyPage mainIndex={MENU_TYPE.NEWS_MANAGE} subIndex={SUB_MENU_TYPE.NEWS_CREATE} />
          }
        />
        <Route
          path="/mypage/news/list"
          element={<MyPage mainIndex={MENU_TYPE.NEWS_MANAGE} subIndex={SUB_MENU_TYPE.NEWS_ALL} />}
        />
        <Route
          path="/mypage/news/news"
          element={<MyPage mainIndex={MENU_TYPE.NEWS_MANAGE} subIndex={SUB_MENU_TYPE.NEWS_NEWS} />}
        />
        <Route
          path="/mypage/news/interview"
          element={
            <MyPage mainIndex={MENU_TYPE.NEWS_MANAGE} subIndex={SUB_MENU_TYPE.NEWS_INTERVIEW} />
          }
        />
        <Route
          path="/mypage/users/member"
          element={
            <MyPage mainIndex={MENU_TYPE.USER_MANAGE} subIndex={SUB_MENU_TYPE.USER_MEMBER} />
          }
        />
        <Route
          path="/mypage/users/adviser"
          element={
            <MyPage mainIndex={MENU_TYPE.USER_MANAGE} subIndex={SUB_MENU_TYPE.USER_ADVISER} />
          }
        />
        <Route
          path="/mypage/users/company"
          element={
            <MyPage mainIndex={MENU_TYPE.USER_MANAGE} subIndex={SUB_MENU_TYPE.USER_COMPANY} />
          }
        />
        <Route
          path="/mypage/users/admin"
          element={<MyPage mainIndex={MENU_TYPE.USER_MANAGE} subIndex={SUB_MENU_TYPE.USER_ADMIN} />}
        />
        <Route
          path="/mypage/users/list/member"
          element={<MyPage mainIndex={MENU_TYPE.USER_MANAGE} subIndex={SUB_MENU_TYPE.USER_LIST} />}
        />
        <Route
          path="/mypage/users/list/adviser"
          element={
            <MyPage mainIndex={MENU_TYPE.USER_MANAGE} subIndex={SUB_MENU_TYPE.ADVISER_LIST} />
          }
        />
        <Route
          path="/mypage/users/list/company"
          element={
            <MyPage mainIndex={MENU_TYPE.USER_MANAGE} subIndex={SUB_MENU_TYPE.COMPANY_LIST} />
          }
        />
        <Route
          path="/mypage/users/list/administrator"
          element={
            <MyPage mainIndex={MENU_TYPE.USER_MANAGE} subIndex={SUB_MENU_TYPE.ADMINISTRATOR_LIST} />
          }
        />
        <Route
          path="/mypage/users/invite"
          element={
            <MyPage mainIndex={MENU_TYPE.USER_MANAGE} subIndex={SUB_MENU_TYPE.INVITE_USER} />
          }
        />

        <Route
          path="/mypage/consult/list"
          element={
            <MyPage mainIndex={MENU_TYPE.CONSULT_MANAGE} subIndex={SUB_MENU_TYPE.CONSULT_LIST} />
          }
        />
        <Route
          path="/mypage/consult/reservation"
          element={
            <MyPage
              mainIndex={MENU_TYPE.CONSULT_MANAGE}
              subIndex={SUB_MENU_TYPE.CONSULT_RESERVATION}
            />
          }
        />

        <Route
          path="/mypage/consult/accepted"
          element={
            <MyPage
              mainIndex={MENU_TYPE.CONSULT_MANAGE}
              subIndex={SUB_MENU_TYPE.CONSULT_ACCEPTED}
            />
          }
        />
        <Route
          path="/mypage/consult/cancel"
          element={
            <MyPage mainIndex={MENU_TYPE.CONSULT_MANAGE} subIndex={SUB_MENU_TYPE.CONSULT_CANCEL} />
          }
        />
        <Route
          path="/mypage/consult/resigned"
          element={
            <MyPage
              mainIndex={MENU_TYPE.CONSULT_MANAGE}
              subIndex={SUB_MENU_TYPE.CONSULT_RESIGNED}
            />
          }
        />
        {/* <Route
          path="/mypage/consult/archive"
          element={
            <MyPage
              mainIndex={MENU_TYPE.CONSULT_MANAGE}
              subIndex={SUB_MENU_TYPE.CONSULT_ARCHIVE}
            />
          }
        /> */}
        <Route
          path="/mypage/books/list"
          element={
            <MyPage mainIndex={MENU_TYPE.BOOK_LIBRARY_MANAGE} subIndex={SUB_MENU_TYPE.BOOKS_LIST} />
          }
        />
        <Route
          path="/mypage/books/create"
          element={
            <MyPage
              mainIndex={MENU_TYPE.BOOK_LIBRARY_MANAGE}
              subIndex={SUB_MENU_TYPE.BOOKS_CREATE}
            />
          }
        />
        <Route path="/space_meeting" element={<SpaceMeetingPage />} />
        <Route path="/book_library" element={<BookLibraryPage />} />
        <Route path="/service_introduction" element={<ServiceIntroductionPage />} />
        <Route path="/job_offer" element={<JobOfferPage />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        <Route path="/term_of_use" element={<TermOfUse />} />
      </Route>
    </Routes>
  )
}
